import { Card, Col, Form, Input, Radio, Row, Select, Spin } from "antd";
import { GET_ALL_TNA_PROCESS_DATA, POST_NEW_TNA_TASK_DATA, UPDATE_NEW_TNA_TASK_DATA } from "apiServices/API_ENDPOINTS";
import { getData, postData, putData } from "apiServices/common";
import HandleNotification from "common/Notification";
import { forwardRef, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { isArrayAndHasValue } from "utils/functions";

const { Option } = Select;

const NewTaskForm = forwardRef((props, ref) => {
  const { form, viewMode, processId } = props;
  const navigate = useNavigate();
  const { newTaskId } = useParams();
  const [processes, setProcesses] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getAllProcesses();
  }, []);

  const onFinish = async (values) => {
    const addQuery = `${POST_NEW_TNA_TASK_DATA}`;
    const editQuery = `${UPDATE_NEW_TNA_TASK_DATA}/${newTaskId}`;
    const bodyData = {
      title: values?.title,
      relation_with: "Style",
      tna_process_id: isArrayAndHasValue(values?.process) ? values?.process[0] : values?.process,
      status: values?.status,
    };

    if (newTaskId > 0) {
      const response = await putData(editQuery, bodyData);
      if (response && response?.code === 200) {
        HandleNotification("success", "Success!", response?.message || "Successfully Updated Task");
        navigate("/tanda/new-task");
      } else {
        HandleNotification("error", "Error!", response?.message || "Failed to Update Task");
      }
    } else {
      const response = await postData(addQuery, bodyData);
      if (response && response?.code === 200) {
        HandleNotification("success", "Success!", response?.message || "Successfully Added Task");
        navigate("/tanda/new-task");
      } else {
        HandleNotification("error", "Error!", response?.message || "Failed to add Task");
      }
    }
  };

  const getAllProcesses = async (filterValues) => {
    setIsLoading(true);
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      ...filterValues,
    };

    const response = await getData(GET_ALL_TNA_PROCESS_DATA, false, bodyData);
    if (response && response?.data?.code === 200) {
      setProcesses(response?.data?.data?.data);
    }
    setIsLoading(false);
  };

  return (
    <Spin spinning={isLoading}>
      <Form
        layout="vertical"
        form={form}
        onFinish={onFinish}
        initialValues={{
          process: processId,
          status: "Yes",
          relation_with: "Style",
        }}
      >
        <Card>
          <Row gutter={6}>
            <Col span={8}>
              <Form.Item
                label="Task Title"
                name="title"
                rules={[
                  {
                    required: true,
                    message: "Task Title is required",
                  },
                ]}
              >
                <Input placeholder="Task Title..." size="small" disabled={viewMode} />
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="Relation With"
                name="relation_with"
                rules={[
                  {
                    required: true,
                    message: "Relation With is required",
                  },
                ]}
              >
                <Select
                  placeholder="Select relation with..."
                  optionFilterProp="children"
                  disabled
                  size="small"
                >
                  <Option value="Style">Style</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="Process"
                name="process"
                rules={[
                  {
                    required: true,
                    message: "Process is required",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select Process..."
                  optionFilterProp="children"
                  disabled={viewMode}
                  size="small"
                  onSearch={(value) => getAllProcesses({ name: value })}
                  allowClear
                >
                  {isArrayAndHasValue(processes) &&
                    processes?.map((process, index) => (
                      <Option value={process?.id} key={process?.id || index}>
                        {process?.title || ""}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                label="Status"
                name="status"
                rules={[
                  {
                    required: true,
                    message: "Status is required",
                  },
                ]}
              >
                <Radio.Group disabled={viewMode}>
                  <Radio value="Yes">Yes</Radio>
                  <Radio value="No">No</Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Form>
    </Spin>
  );
});

export default NewTaskForm;
